import Button from '@components/Button';
import Row from '@components/Row';
import { useFlow } from '@stackflow/react';
import { useAtom } from 'jotai';
import { Fragment } from 'react';

import { isDeletingAtom } from '../../atoms/myMenuAtoms';

function MyMenuFooter() {
    const [isDeleting, setIsDeleting] = useAtom(isDeletingAtom);
    const { push } = useFlow();
    const handleDelete = () => {
        setIsDeleting(false);
        push('AlertActivity', { message: '삭제되었습니다.' });
    };
    if (isDeleting) {
        return (
            <Row spacing={3} fullWidth>
                <Button variant='tone' fullWidth size='medium'>취소</Button>
                <Button fullWidth size='medium' onClick={handleDelete}>
                  삭제
                </Button>
            </Row>
        );
    }
    return (<Fragment/>);
}

export default MyMenuFooter;
